import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PutProjectFormFields {

    public name: FormField
    public description: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          false,
        )
        this.description = new FormField(
          'description',
          'Description',
          null,
          FormFieldType.text,
          false,
          true,
          ""
        )

    }
}

const fields = new PutProjectFormFields()

export const putProjectFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  description: fields.description,
};